import avi from '../images/avi.svg';
import doc from '../images/doc.svg';
import file from '../images/file.svg';
import jpg from '../images/jpg.svg';
import midi from '../images/midi.svg';
import mov from '../images/mov.svg';
import mp3 from '../images/mp3.svg';
import pdf from '../images/pdf.svg';
import png from '../images/png.svg';
import ppt from '../images/ppt.svg';
import psd from '../images/psd.svg';
import txt from '../images/txt.svg';
import xls from '../images/xls.svg';
import zip from '../images/zip.svg';

const extensionImages = { avi, doc, file, jpg, midi, mov, mp3, pdf, png, ppt, psd, txt, xls, zip,
    docx:doc, jpeg:jpg, pptx:ppt, xlsx:xls
};

const imageForExtension = ( ext )=>{

    if( !ext )
        return null;

    const normalized = ext.trim().toLowerCase();

    if( extensionImages[normalized] )
        return extensionImages[normalized];

    return file;

};

export { extensionImages, imageForExtension };


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Files/services/format-images.js